import type { CSSProperties } from "react";
import type { PageThemeTokens } from "./types";

/** 将 PageThemeTokens 转为 CSS 变量，供 V2 聊天区等样式引用 */
export function tokensToCssVars(tokens: PageThemeTokens): CSSProperties {
  return {
    "--uchat-v2-page-bg": tokens.background,
    "--uchat-v2-message-bg": tokens.messageBg,
    "--uchat-v2-agent-bubble-bg": tokens.chatAgentBubbleBg,
    "--uchat-v2-agent-bubble-border": tokens.chatAgentBubbleBorder,
    "--uchat-v2-message-text": tokens.chatMessageText,
    "--uchat-v2-user-gradient-start": tokens.chatUserGradientStart,
    "--uchat-v2-user-gradient-end": tokens.chatUserGradientEnd,
    "--uchat-v2-user-message-text": tokens.chatUserMessageText,
    "--uchat-v2-input-field-bg": tokens.chatInputFieldBg,
    "--uchat-v2-input-text": tokens.chatInputText,
    "--uchat-v2-input-placeholder": tokens.chatInputPlaceholder,
    "--uchat-v2-sender-bg": tokens.senderBg,
    "--uchat-v2-media-bg": tokens.chatMediaBg,
    "--uchat-v2-icon-color": tokens.chatIconColor,
    "--uchat-v2-link-color": tokens.chatLinkColor,
    "--uchat-v2-accent": tokens.accent,
    "--uchat-v2-status-ending": tokens.statusEnding,
    "--uchat-v2-border": tokens.border,
    "--uchat-v2-attachment-bg": tokens.cardBg,
  } as CSSProperties;
}
